import { useEffect, useRef, useState } from 'react';
import { useConversation } from 'hooks/conversation';
import { scrollToMessagesListBottom } from 'utils/message';
import { htmlId } from 'utils/html';
import { TypingAnimation } from 'components/Animations';

import { Container, Content } from './TypingIndicator.styles';
import { TypingIndicatorProps } from './TypingIndicator.types';
import { useView } from 'hooks/view';

const TypingIndicator = (props: TypingIndicatorProps) => {
  const { animate, children, duration, isAutoScrollToBottom, relativeIndex } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const { conversationState } = useConversation();
  const { viewState } = useView();

  const [visible, setVisible] = useState(true);

  /**
   * Behavior with advocate in conversation is slightly different from System (Sebastian)
   * that automatically appends typing animation on receipt.
   */
  const isAdvocateInConvo = conversationState.participants.advocates.length > 0;
  const isLastMsgInView = viewState.scrollToBottom.isLastMsgInView;

  const isNoScrollCondition = isAdvocateInConvo && !isAutoScrollToBottom; // FIXME - may work function wise, but not as expected in code
  const isNoScrollOutOfView = !isLastMsgInView;

  useEffect(() => {
    if (visible && isAutoScrollToBottom) {
      scrollToMessagesListBottom(500); // scroll newest nested message into view (for multi forms).
    }
  }, [visible]);

  useEffect(() => {
    if (isAdvocateInConvo && !isAutoScrollToBottom) {
      setVisible(false);
      return;
    }
    if (animate) {
      !isNoScrollCondition && !isNoScrollOutOfView && scrollToMessagesListBottom(500); // immediately scroll to bottom to show animation
      const timeout = setTimeout(() => {
        // FIXME - callback for async visible state setter. Will not scroll to bottom
        //         without (full length content now loaded). Investigate if optimization possible.
        setVisible(false);
      }, duration);
      return () => clearTimeout(timeout);
    }
  }, []);

  if (!visible || !animate)
    return (
      <Content id={htmlId('typing-indicator-content-ease-in')} ref={contentRef}>
        {children}
      </Content>
    );

  // FIXME - to improve. Typing indicator is only visible for first messages. Subsequent extension messages only have a
  //         delay imposed by parent WithDelayedAnimation. No animation, hence return null for index !== 0.
  //         This whole structure should be revisited after clarification from product requirements.
  if (relativeIndex === 0) {
    return (
      <Container id={htmlId(`typing-indicator-${relativeIndex}`)} ref={containerRef}>
        <TypingAnimation />
      </Container>
    );
  } else {
    return null;
  }
};

export default TypingIndicator;
